import React, { useEffect, useRef } from "react";
import "./TecnologiaModal.css";
import "materialize-css/dist/css/materialize.min.css";
import M from "materialize-css";

export default function TecnologiaModal({ tecnologia, onClose, onExpand }) {
  const modalRef = useRef(null);
  const instanceRef = useRef(null);
  const carouselRef = useRef(null);
  const carouselInstanceRef = useRef(null);

  useEffect(() => {
    if (!modalRef.current) return;

    instanceRef.current = M.Modal.init(modalRef.current, {
      dismissible: true,
      onCloseEnd: () => {
        document.body.style.overflow = '';
        document.body.classList.remove('modal-open');
        onClose && onClose();
      },
        preventScrolling: true, 
        inDuration: 200,
        outDuration: 200,
        startingTop: '5%',
        endingTop: '5%'
    });

    instanceRef.current.open();

    return () => {
      if (instanceRef.current) {
        instanceRef.current.destroy();
      }
      document.body.style.overflow = '';
      document.body.classList.remove('modal-open');
    };
  }, [tecnologia]);

  useEffect(() => {
    if (!tecnologia || !carouselRef.current) return;

    carouselInstanceRef.current = M.Carousel.init(carouselRef.current, {
      fullWidth: false,
      indicators: false,
      numVisible: 3,
      padding: 0,
      shift: 0,
      dist: 0,
      duration: 0
    });

    return () => {
      carouselInstanceRef.current?.destroy();
    };
  }, [tecnologia]);

  if (!tecnologia) return null;

  const clickNext = () => {
    carouselInstanceRef.current?.set(carouselInstanceRef.current.center + 1);
  };

  const clickPrev = () => {
    carouselInstanceRef.current?.set(carouselInstanceRef.current.center - 1);
  };

  return (
    <div
      ref={modalRef}
      id="tecnologiaModal"
      className="modal tecnologia-materialize-modal"
    >
      <div className="modal-content tecnologia-modal-container">
        <button className="btn-close-icon" onClick={() => instanceRef.current?.close()}>
          <i className="material-icons">close</i>
        </button>

        <h4 className="modal-title-page-corpo">
          {tecnologia.titulo}
        </h4>

        {/* Primeira linha: duas colunas */}
        <div className="modal-content-main-card">
          <div className="modal-left-content">
            <p className="modal-description-page-corpo">
              {tecnologia.descricao}
            </p>
          </div>

          <div className="modal-right-video">
            <div className="video-wrapper">
              {tecnologia.video ? (
                <iframe
                  src={tecnologia.video}
                  allowFullScreen
                  title="Vídeo da Tecnologia" 
                />
              ) : (
                <div className="video-placeholder">
                  <i className="material-icons">play_arrow</i>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Segunda linha: carrossel ocupando as duas colunas */}
        {tecnologia.beneficios?.length > 0 && (
          <div className="carousel-beneficios-wrapper">
            <button className="carousel-arrow left" onClick={clickPrev}>
              <i className="material-icons">chevron_left</i>
            </button>

            <div className="carousel carousel-beneficios" ref={carouselRef}>
              {tecnologia.beneficios.map((b, i) => (
                <a key={i} className="carousel-item">
                  <div className="beneficio-card">
                    {b.icone && <i className={`bi ${b.icone} beneficio-icon`}></i>}
                    <strong className="beneficio-titulo">{b.titulo}</strong>
                    <p className="beneficio-subtitulo">{b.subtitulo}</p>
                  </div>
                </a>
              ))}
            </div>

            <button className="carousel-arrow right" onClick={clickNext}>
              <i className="material-icons">chevron_right</i>
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
